// src/store/store.js - COMPLETE WITH ORDER MANAGEMENT
import { configureStore } from '@reduxjs/toolkit';
import authReducer, { logoutAdmin } from './slices/authSlice';
import adminManagementReducer from './slices/adminManagementSlice';
import userManagementReducer from './slices/userManagementSlice';
import productManagementReducer from './slices/productManagementSlice';
import orderManagementReducer from './slices/orderManagementSlice'; // ✅ NEW IMPORT
import maintenanceReducer from './slices/maintenanceSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    adminManagement: adminManagementReducer,
    userManagement: userManagementReducer,
    productManagement: productManagementReducer,
    orderManagement: orderManagementReducer, // ✅ NEW REDUCER ADDED
    maintenance: maintenanceReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Handle unauthorized events globally
window.addEventListener('unauthorized', () => {
  store.dispatch(logoutAdmin());
});

export default store;